/* ANALYTICS SERVER SIDE METHODS */
(function($) {
  "use strict";

  var main = null;

  var getAndUpdateLocalStorageGAId = function(timestamp) {
    var data = localStorage.getItem("dkt_ga_clientId");
    if (data) {
      data = JSON.parse(data);
      if (data.expires > new Date().getTime()) {
        data.expires = timestamp;
        setLocalStorageGAClientId(data.clientId, timestamp);
        return data;
      }
    }
    return null;
  }

  var setLocalStorageGAClientId = function(clientId, expires) {
    localStorage.setItem("dkt_ga_clientId", JSON.stringify({ expires: expires, clientId: clientId }));
  }


  var getClientId = function() {
    var timestamp = new Date().getTime() + parseInt("34187400000", 10);
    var _localData = getAndUpdateLocalStorageGAId(timestamp);
    if (_localData) {
      return _localData.clientId;
    } else {
      var tmp = "DKT-" + tc_vars["user_id_platform"];
      setLocalStorageGAClientId(tmp,timestamp);
      return tmp;
    }
  }

  var CUBE = window.CUBE || {};
  var fwk = CUBE.Anly ? CUBE.Anly : { Anly: {} };

  fwk.serverside = {
    // Construct and encode a key / value parameter for server side
    buildParam: function(name, value) {
        return name + "=" + encodeURIComponent(value);
    },

    // Generates the COMMON data to send with each Analytics HIT
    getGACommon: function() {
        var params = [];
        var build = this.buildParam;

        var url = window.location.origin + '/' + location.pathname.split('/')[1] + '/' + 'checkoutPaymentServerSide';
        var tid = '';
        var cid = getClientId() || '';

        if (typeof tC !== 'undefined' && !!tC.internalvars && !!tC.internalvars.ua_id)
          tid = tC.internalvars.ua_id;

        var gaCookie = document.cookie.split(";").find(i => i.indexOf('_ga') > -1);
        if (!!gaCookie && gaCookie.indexOf('=') > -1) {
          gaCookie = gaCookie.split('=')[1];
        }

        params.push(build("v", "1"));
        params.push(build("tid", tid)); // GA Account
        params.push(build("cid", cid));// User ID
        params.push(build("cu", tc_vars.env_currency));   // Currency
        params.push(build("ua", navigator.userAgent));    // User Agent
        params.push(build("de", document.charset));     // Document Encoding type
        params.push(build("ul", navigator.language));   // User Language code
        params.push(build("dl", url));            // Document Location
        params.push(build("dt", document.title));     // Document Title
        params.push(build("z", Date.now()));        // Cache reference

        return params.join("&");
    },

    // Generates the CUSTOM DIMENSIONS data to send with each Analytics HIT
    getGADimensions: function(isVirtualPage) {
      if ('undefined' !== typeof ga) {
        var tracker = ga.getByName('transcript') || ga.getByName('decathlon');
        //Get GAFramework from virtual page
        if (typeof isVirtualPage !== "undefined" && isVirtualPage) {
          var ifrm = window.frames['virtual-page'];
          try {
            ifrm = (ifrm.contentWindow) ? ifrm.contentWindow : (ifrm.contentDocument.document) ? ifrm.contentDocument.document : ifrm.contentDocument;
          } catch(e) {
            ifrm = undefined;
          }
          if ('undefined' !== typeof ifrm && 'undefined' !== typeof ifrm.ga) {
            tracker = ifrm.ga.getByName('transcript');
          }
        }
        if(tracker) {
          var dimensions = '';
          for (var i = 1; i < 201; i++) {
            var value = tracker.get('dimension' + i);
            if (!!value) {
              dimensions += 'cd' + i + '=' + value + '&';
            }
          }
          dimensions = dimensions.substr(0, dimensions.length);
          // Check if string is already encoded
          if (decodeURIComponent(dimensions) === dimensions)
            return encodeURIComponent(dimensions);
          else
            return dimensions;
        }
      }
      return " ";
    },
  };

  main = CUBE.Anly;
  window.CUBE.Anly = fwk;
})(jQuery);



// WEBPACK FOOTER //
// ./src/analytics/transcript-workaround/server-side.js